import { BdResource } from '@bindoc-projects/resource-domain-lib';

export const BD_RESOURCES_LIST_OPTIONS_DISABLE_FNC_DEFAULT = () => false;
export const BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT = () => true;
export const BD_RESOURCES_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT = (
  resource: BdResource,
) => [`/${resource.resourceName}`, resource.id];

export interface BdResourcesListConfig<
  TResource extends BdResource = BdResource,
> {
  disableFnc: (resource: TResource) => boolean;
  filterFnc: (resource: TResource) => boolean;
  detailLinkFnc: (resource: TResource) => string[];
  emptyResourcesText: string;
  showLabelsColumn?: boolean;
}

export const BD_RESOURCES_LIST_OPTIONS_DEFAULT: BdResourcesListConfig = {
  disableFnc: BD_RESOURCES_LIST_OPTIONS_DISABLE_FNC_DEFAULT,
  detailLinkFnc: BD_RESOURCES_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT,
  filterFnc: BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
  emptyResourcesText: 'Keine Elemente gespeichert',
};
